<template>
    <layout>
        <div class="app-container" v-if="!processing">
            <project-nav/>
            <div class="app-body">
                <router-view/>
            </div>
        </div>
    </layout>
</template>
<script>
import ProjectNav from '../components/Project/Nav/ProjectNav';
import Layout from '@/components/Layout/Layout';

export default {
    components: {Layout, ProjectNav},
    data() {
        return {
            processing: false,
        }
    },
    beforeMount() {
        this.processing = true;
        this.$store.dispatch('projects/init')
            .finally(() => this.processing = false);
    }
}
</script>
